// Dominio SG — Software Ganadero (admin-sg.md). Constantes de dominio.
//
// El navegador del usuario final es por VACA FÍSICA (conciliadas + activas); el
// backend garantiza ese scope, así que aquí NO viven estados de match/ficha ni de
// backups (eso es operación interna). Solo la subida del .zip (acción gated).

// Subida del backup .zip (POST binario crudo, admin-sg.md). El backend limita a
// 60 MB (SG_UPLOAD_LIMIT → 413 si excede). El POST corre las 3 fases del pipeline
// de forma síncrona, así que el request necesita un timeout amplio (el default de
// la instancia es 15s — insuficiente).
export const MAX_ZIP_BYTES = 60 * 1024 * 1024;
export const SG_UPLOAD_TIMEOUT_MS = 120_000;
